import { useSsoService } from "../../../../hooks"
import { maskEmail } from "../../../../utils/maskEmail"

export const useEmailSentDialog = () => {
  const email = useSsoService().getEmail() ?? ""

  return {
    email: maskEmail(email),
  }
}
